import { useState } from 'react';
import Login from "../auth/Login";
import Register from "../auth/Register";

export default function AuthScreen({ setAuthenticated }) {
  const [showRegister, setShowRegister] = useState(false);

  return (
    <div className="auth-screen">
      <h1 className="auth-title">Aigribot Dashboard</h1>

      <div className="auth-box">
        <div className="auth-column">
          <Login onLogin={() => setAuthenticated(true)} onShowRegister={() => setShowRegister(true)} />
        </div>
      </div>

      {/* Register Modal */}
      {showRegister && (
        <div className="modal-overlay" onClick={() => setShowRegister(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowRegister(false)}>
              ×
            </button>
            <Register onClose={() => setShowRegister(false)} />
          </div>
        </div>
      )}
    </div>
  );
}
